import { Typography } from 'glints-aries';
import { Divider as AriesDivider, Link } from 'glints-aries/lib/@next';
import styled from 'styled-components';

export const Divider = styled(AriesDivider)`
  height: 1px;
`;

export const Title = styled(Typography.Title).attrs({ tag: 'h1' })`
  position: relative;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  line-height: 48px;

  #third-party-login-info {
    margin-top: 30px;
  }
`;

export const GlintsLink = styled(Link)`
  display: block;
  text-align: center;
`;
